import type { WordLimit } from "@memorang/types";
import Box from "../../../Box";
import useWritingTimer from "../../hooks/useWritingTimer";
import ItemStem from "../ItemStem";
import WritingInput from "../WritingInput";
import { ItemInstruction } from "./pte/ItemInstruction";

type Props = {
	stimulusText: string;
	instruction: string;
	value?: string;
	onChangeText: (value: string) => void;
	disabled?: boolean;
	wordLimit?: WordLimit;
	timeLimit?: number;
	initialElapsedSeconds?: number;
	onResponseComplete?: () => void;
};

const SummarizeWrittenText = ({
	stimulusText,
	instruction,
	value,
	onChangeText,
	disabled,
	wordLimit,
	timeLimit,
	initialElapsedSeconds,
	onResponseComplete,
}: Props) => {
	const writingTimer = useWritingTimer({
		timeLimit,
		startTrigger: "mount",
		disabled,
		initialElapsedSeconds,
		onExpire: onResponseComplete,
	});

	return (
		<Box gap={16}>
			<Box>
				<ItemInstruction instruction={instruction} />
				<ItemStem text={stimulusText} userSelect="text" />
			</Box>
			<Box gap={4}>
				<WritingInput
					value={value}
					onChangeText={onChangeText}
					disabled={disabled || writingTimer.isExpired}
					isAnswered={disabled}
					wordLimit={wordLimit}
					autoExpand
					showWordLimitError={false}
				/>
			</Box>
		</Box>
	);
};

export default SummarizeWrittenText;
